import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Card, Grid, Icon } from "@mui/material";
import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import MDButton from "shared/components/MDButton";
import CustomModal from "shared/components/MDmodal/CustomModal";
import FormZone from "../Form/FormZone";
import { createZoneService } from "modules/bitacora/services/Configuracion/Zona/zonaService";

const HeaderZona = ({ children, onZoneCreated }) => {
  const [open, setOpen] = useState(false);

  const handleCreate = async (data) => {
    const created = await createZoneService(data);
    onZoneCreated(created);
    setOpen(false);
  };

  return (
    <MDBox position="relative" sx={{ mt: -2, mx: -3, py: 2, px: -2 }}>
      <Card sx={{ mt: 1, mx: 3, py: 2, px: 2 }}>
        <Grid container alignItems="center" justifyContent="space-between" spacing={3}>
          <Grid item>
            <MDTypography variant="h5" fontWeight="medium">
              Zonas
            </MDTypography>
          </Grid>
          <Grid item>
            <MDButton
              variant="gradient"
              color="success"
              startIcon={<Icon>add</Icon>}
              onClick={() => setOpen(true)}
            >
              Crear nueva Zona
            </MDButton>
          </Grid>
        </Grid>
        {children}
      </Card>
      <CustomModal open={open} onClose={() => setOpen(false)} title="Crear Zona">
        <FormZone onSubmit={handleCreate} afterSubmit={() => {}} />
      </CustomModal>
    </MDBox>
  );
};

HeaderZona.defaultProps = {
  children: "",
  onZoneCreated: null,
};

HeaderZona.propTypes = {
  children: PropTypes.node,
  onZoneCreated: PropTypes.func,
};

export default HeaderZona;
